import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles, CircularProgress } from '@material-ui/core';
import { FHEReactSelect } from 'data/components';
import { Toastr, icons } from 'data/common';
import memoizeOne from 'memoize-one';
import { setEnv } from '../../../data/Environments/actions';
import { setPack } from '../../../data/Packs/actions';
import envConfig from 'conf/environments';

class SelectBar extends PureComponent {
    static propTypes = {
        setEnv: PropTypes.func.isRequired,
        setPack: PropTypes.func.isRequired,
        classes: PropTypes.object.isRequired,
        profile: PropTypes.object.isRequired,
        envList: PropTypes.array.isRequired,
        envBox: PropTypes.string.isRequired,
        packList: PropTypes.object.isRequired,
        packBox: PropTypes.string.isRequired,
        disabled: PropTypes.bool
    };
    static defaultProps = {
        disabled: false
    };

    constructor(props) {
        super(props);
        this.state = {
            selectEnvLoading: false,
            envBox: props.envBox
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { envBox } = state;
        const { envBox: envBoxProps } = props;

        if (envBox !== envBoxProps)
            return {
                envBox: envBoxProps
            };

        return null;
    }

    handleChangePack = event => {
        const { setPack } = this.props;
        setPack(event.target.value);
    };

    getEnvChoices = () => {
        const { classes, profile, envList } = this.props;
        let res = [];
        envList.map(envName => {
            if (profile.get('admin') || profile.getIn(['user_rights', 'testbench'], []).includes(`boxes_${envName}`))
                res.push({
                    value: envName,
                    label: (
                        <div className={classes.iconContainer}>
                            <img className={classes.envIcon} src={icons[envName]} alt="icon" />
                            <div className={`${classes.envTitle}`}>
                                {Translator.translate(envName === 'empty' ? 'testbench.center.title' : `${envName}.centerName`)}
                            </div>
                        </div>
                    )
                });
        });
        return res;
    };

    getPackChoices = () => {
        const { packList } = this.props;
        let res = [];

        packList.map((pack, packName) => {
            res.push({
                value: packName,
                label: <div> {Translator.translate(`testbench.packs`, packName)}</div>
            });
        });
        return res;
    };

    getSelectedEnv = memoizeOne(env => {
        const choices = this.getEnvChoices();
        return choices.find(x => x.value === env);
    });

    getSelectedPack = memoizeOne(pack => {
        const choices = this.getPackChoices();
        return choices.find(x => x.value === pack);
    });

    handleReactSelect = (event, options) => {
        const { setPack, setEnv, envBox } = this.props;

        if (options.name === 'choiceEnv') {
            this.setState({ selectEnvLoading: true, envBox: event.value });
            setEnv(event.value)
                .then(() => {
                    Toastr.success(Translator.translate(`testbench.setEnv.success`, Translator.translate(`${event.value}.centerName`)));
                    this.setState({ selectEnvLoading: false });
                })
                .catch(err => {
                    Toastr.error(Translator.translate(`testbench.setEnv.error`), err);
                    this.setState({ selectEnvLoading: false, envBox: envBox });
                });
        } else if (options.name === 'choicePack') {
            setPack(event.value);
        }
    };

    render() {
        const { selectEnvLoading, selectPackLoading, envBox } = this.state;
        const { classes, disabled, packBox } = this.props;
        return (
            <div className={classes.subMenuFixedDiv}>
                {selectEnvLoading && <CircularProgress size={20} color="inherit" />}
                <div className={classes.selectContainer}>
                    <FHEReactSelect
                        placeholder={Translator.translate(`testbench.selectEnvtitle`)}
                        name="choiceEnv"
                        disabled={disabled}
                        onChange={this.handleReactSelect}
                        value={this.getSelectedEnv(envBox)}
                        choices={this.getEnvChoices()}
                    />
                </div>
                {selectPackLoading && <CircularProgress size={20} color="inherit" />}
                <div className={classes.selectContainer}>
                    <FHEReactSelect
                        name="choicePack"
                        disabled={disabled}
                        onChange={this.handleReactSelect}
                        value={this.getSelectedPack(packBox)}
                        choices={this.getPackChoices()}
                    />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        profile: state.data.user,
        envBox: state.environments.testbench.data.Environments.get('active'),
        envList: envConfig.testbench.envList,
        packBox: state.environments.testbench.data.Packs.get('active'),
        packList: state.environments.testbench.data.Packs.get('list')
    };
}

const styles = theme => ({
    selectContainer: {
        minWidth: 280,
        marginLeft: 20,
        marginTop: 10
    },
    iconContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    envIcon: {
        width: 20,
        height: 20
    },
    envTitle: {
        marginLeft: 5
    },
    subMenuFixedDiv: {
        position: 'fixed',
        width: '100%',
        top: 64,
        left: 0,
        maxWidth: '100vw',
        zIndex: 15,
        height: 50,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.background.paper
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ setEnv, setPack }, dispatch)
    )(withStyles(styles, { withTheme: true })(SelectBar))
);



// WEBPACK FOOTER //
// ./environments/testbench/scenes/Boxes/components/SelectBar.js